export const environment = {
    apiMain: 'http://api-ach.erpbucket.com',
    gateway: false,
};
